<script>
import SelectComponent from '@/plugins/form/__components/SelectOne.vue';
import MixinItem from '@/plugins/form/__mixins/item';

export default {
  mixins: [MixinItem],
  components: {
    SelectComponent,
  },
  props: {
    value: {},
  },
  data: () => ({
    form: null,
  }),
  methods: {
    handlerSubmit() {
      this.form = this.module.addForm();
      this.form.init();
      this
        .$fDialog(this.form, {
          title: `Добавление: ${this.module.label}`,
        })
        .then((data) => {
          this.module.getOptions();
          this.$emit('input', data);
        })
        .finally(() => {
          setTimeout(() => {
            this.form = null;
          });
        });
    },
  },
  mounted() {
  },
};
</script>
<template>
  <div class="f-flex">
    <SelectComponent
      class="f-flex__auto"
      :value="value"
      :placeholder="placeholder"
      :disabled="module.disabled"
      :options="module.options"
      :multiple="module.multiple"
      :clearable="module.clearable"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
      @input="$emit('input', $event)"
      @change="$emit('change', $event)"
      @submit="$emit('submit', $event)"
    />
    <div class="f-flex__shink">
      <FItemBtn
        v-if="module.showAdd"
        icon="el-icon-plus"
        @click="handlerSubmit"
      />
    </div>
  </div>
</template>
